import React from 'react'
import Box from '../../../../../core/components/box/Box'
import {TertiaryButtonDark} from '../../../../../core/components/unilink/index'
import JourneyChunk from './JourneyChunk'
import RecentSubjects, {MobileRecentSubjects} from './RecentSubjects'
import LoadingSpinner from '../../../../../core/components/loading-spinner/LoadingSpinner'
import './journey.css'

class Journey extends React.PureComponent {
  render() {
    const {bucketedJourney, className, recentSubjects, loading, canLoadMore, showMore} = this.props
    let journeyChunks = []
    if (loading && !bucketedJourney) {
      journeyChunks = <JourneyChunk
        loading />
    } else {
      journeyChunks = bucketedJourney.ordering.map((timeago)=>(
        <JourneyChunk
          key={timeago}
          timeago={timeago}
          entries={bucketedJourney.chunks[timeago]}
        />
      ))
    }
    const content = journeyChunks
    const classNames = ['journey']
    if (className) {
      classNames.push(className)
    }
    return (
      <div>
        <Box display='none' smDisplay='block'>
          <div className='journey'>
            <div className={className}>
              <div className='journey__container'>
                <Box display='flex' justifyContent='between'>
                  <Box column={8} flexShrink={0} display='flex' direction='column'>
                    {content}
                    {
                      canLoadMore
                        ? <Box
                          column={11}
                          display='flex'
                          justifyContent='center'
                          alignItems='center'
                          alignSelf='end'>
                          {
                            loading
                              ? <LoadingSpinner noMargin />
                              : <TertiaryButtonDark
                                onClick={showMore}>
                              Show More
                              </TertiaryButtonDark>
                          }
                        </Box>
                        : null
                    }
                  </Box>
                  <Box column={4} marginTop={10} marginLeft={8}>
                    {
                      loading && !bucketedJourney
                        ? null
                        : <RecentSubjects recentSubjects={recentSubjects} />
                    }
                  </Box>
                </Box>
              </div>
            </div>
          </div>
        </Box>
        <Box display='block' smDisplay='none'>
          <div className='journey'>
            <div className={className}>
              <div className='journey__container'>
                <MobileRecentSubjects recentSubjects={recentSubjects} />
                <div>
                  {content}
                  {
                    canLoadMore
                      ? <Box
                        column={11}
                        display='flex'
                        justifyContent='center'
                        alignItems='center'
                        alignSelf='end'>
                        {
                          loading
                            ? <LoadingSpinner noMargin />
                            : <TertiaryButtonDark
                              onClick={showMore}>
                            Show More
                            </TertiaryButtonDark>
                        }
                      </Box>
                      : null
                  }
                </div>
              </div>
            </div>
          </div>
        </Box>
      </div>
    )
  }
}

export default Journey



// WEBPACK FOOTER //
// ./src/domains/home/logged-in-home/journey/components/Journey.js